import usePatientProfileTabs from "./usePatientProfileTabs";
import { useSelector } from "react-redux";

const PatientProfileTabContent = () => {
  const { profileTab } = useSelector((state) => state.transmission);
  const [tabs] = usePatientProfileTabs();
  return (
    <div style={{ marginTop: "12px" }}>
      {tabs?.find(({ value }) => value === profileTab)?.component}
    </div>
  );
};

export default PatientProfileTabContent;
